import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Flower2 } from "lucide-react";

export default function PayResume() {
  const { registrantId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let done = false;
    api
      .post(`/public/pay/${registrantId}`, { origin: window.location.origin })
      .then((r) => {
        if (done) return;
        if (r.data.paid) {
          toast.success("You're all set, this experience is already paid for.");
          navigate("/account");
        } else if (r.data.url) {
          window.location.href = r.data.url;
        } else {
          setError("We couldn't start checkout. Please try again.");
        }
      })
      .catch((err) => {
        if (done) return;
        setError(formatApiError(err.response?.data?.detail) || "We couldn't find that reservation.");
      });
    return () => { done = true; };
  }, [registrantId, navigate]);

  return (
    <div className="wellness min-h-screen bg-[#FBFAFF] flex items-center justify-center px-6" data-testid="pay-resume">
      <div className="text-center max-w-md">
        <Flower2 className="w-8 h-8 text-[#7B2CBF] mx-auto mb-5" strokeWidth={1.5} />
        {error ? (
          <>
            <h1 className="text-2xl font-light mb-3">Something went wrong</h1>
            <p className="text-[#6A6588] mb-6" data-testid="pay-resume-error">{error}</p>
            <button onClick={() => navigate("/")} className="btn-gradient text-white px-6 py-3 rounded-full font-medium">
              Back to home
            </button>
          </>
        ) : (
          <>
            <div className="flex items-center justify-center gap-2 text-[#6A6588]">
              <Loader2 className="w-5 h-5 animate-spin" /> Taking you to secure checkout…
            </div>
          </>
        )}
      </div>
    </div>
  );
}
